import type { PriceCompareItem } from '../types/PriceCompareItem';

import { createPriceCompareItem } from './createPriceCompareItem';

export const calculatePriceCompareItem = (item: PriceCompareItem): PriceCompareItem => {
    const calculatedItem = createPriceCompareItem(item);
    calculatedItem.units = Number(calculatedItem.units);
    calculatedItem.compute();
    return calculatedItem;
};
